import axios from 'axios'
import { Toast } from 'vant'

// mall H5 免登录接口,独立 axios 实例(不带 Authorization,不触发登录跳转)
// baseURL 按部署环境配置 VUE_APP_MALL_API,默认与主系统同域名(不含 /api 前缀)
const mallRequest = axios.create({
  baseURL: process.env.VUE_APP_MALL_API || 'https://yisheng.healthmore.net',
  timeout: 30000
})

mallRequest.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code !== 200) {
      Toast(res.msg || 'Error')
      return Promise.reject(new Error(res.msg || 'Error'))
    }
    return res
  },
  error => {
    Toast(error.message || '请求失败')
    return Promise.reject(error)
  }
)

// 获取电商公众号appid(微信网页授权用)
export function mallH5WxConfig() {
  return mallRequest({ url: '/api/mall/wxConfig', method: 'get' })
}

// H5 商品列表(已上架)
export function mallH5ProductList(params) {
  return mallRequest({ url: '/api/mall/product/list', method: 'get', params })
}

// 商品分类列表
export function mallH5ProductCategories() {
  return mallRequest({ url: '/api/mall/product/categories', method: 'get' })
}

// H5 商品详情
export function mallH5ProductDetail(productId) {
  return mallRequest({ url: '/api/mall/product/detail', method: 'get', params: { productId } })
}

// H5 订单详情
export function mallH5OrderDetail(orderNo) {
  return mallRequest({ url: '/api/mall/order/detail', method: 'get', params: { orderNo } })
}

// 下单并发起支付(走 orgPay)
export function mallH5CreateOrder(data) {
  return mallRequest({ url: '/api/orgPay/getMallPayConfig', method: 'post', data })
}

// 查询支付状态
export function mallH5SelectPayState(orderNo, end) {
  return mallRequest({ url: '/api/orgPay/selectMallPayState', method: 'post', params: { orderNo, end } })
}

// 订单查询:发送短信验证码
export function mallH5OrderSendCode(data) {
  return mallRequest({ url: '/api/mall/order/sendCode', method: 'post', data })
}

// 订单查询:按收货手机号查询订单(首次带验证码,翻页不带)
export function mallH5OrderListByPhone(data) {
  return mallRequest({ url: '/api/mall/order/listByPhone', method: 'post', data })
}
